class SymfonyErrorFormatter {
    static clean(errors) {
        if (
            !(typeof errors.data === 'undefined') &&
            !(typeof errors.data.errors === 'undefined') &&
            !(typeof errors.data.errors.children === 'undefined')
        ) {
            let cleanErrors = [];
            if (
                !(typeof errors.data === 'undefined') &&
                !(typeof errors.data.errors === 'undefined') &&
                !(typeof errors.data.errors.children === 'undefined') &&
                !(typeof errors.data.errors.children.password === 'undefined')
            ) {
                let errorObject = errors.data.errors.children.password.children;
                let currentPwError = errors.data.errors;
                if (currentPwError.errors) {
                    let messages = [];
                    currentPwError.errors.forEach(function (error) {
                        messages.push({
                            message: error
                        });
                    });

                    cleanErrors.push({
                        $name: "Password",
                        $submitted: true,
                        $invalid: true,
                        $error: messages
                    });
                }
                for (let [key, value] of Object.entries(errorObject)) {
                    let messages = [];
                    if (typeof value.errors === 'undefined') {
                        continue;
                    }
                    value.errors.forEach(function (error) {
                        messages.push({
                            message: error
                        });
                    });

                    cleanErrors.push({
                        $name: key,
                        $submitted: true,
                        $invalid: true,
                        $error: messages
                    });
                }
            }
            let messages = [];
            let errorObject = errors.data.errors.children;
            for (let [key, value] of Object.entries(errorObject)) {
                if (value.children) {
                    let childrenObject = value.children;
                    for (let [childKey, childValue] of Object.entries(childrenObject)) {
                        if (typeof childValue.errors === 'undefined') {
                            continue;
                        }
                        childValue.errors.forEach(function (error) {
                            messages.push({
                                message: error
                            });
                        });

                        cleanErrors.push({
                            $name: childKey,
                            $submitted: true,
                            $invalid: true,
                            $error: messages
                        });
                    }
                }
                if (typeof value.errors === 'undefined') {
                    continue;
                }
                value.errors.forEach(function (error) {
                    messages.push({
                        message: error
                    });
                });

                cleanErrors.push({
                    $name: key,
                    $submitted: true,
                    $invalid: true,
                    $error: messages
                });
            }
            return Promise.reject(cleanErrors);
        } else if (
            !(typeof errors.data === 'undefined') &&
            !(typeof errors.data.error === 'undefined')
        ) {
            if (!(typeof errors.data.error.exception === 'undefined')) {
                return Promise.reject([
                    {
                        $error: errors.data.error.exception[0].message
                    }
                ]);
            }
            return Promise.reject([
                {
                    $error: errors.data.error.message
                }
            ]);
        }
        return Promise.reject([
            {
                $error: 'Unknown Error'
            }
        ]);
    }
}

export default SymfonyErrorFormatter;
